<template>
    <div
        class="favorites-toggle"
        @click.prevent="toggleFavorite"
    >
        <span
            title="Remove from favourites"
            class="icon-link favorites-toggle__on"
            v-if="value"
        >
            <svg viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="#svg-icn-fav-on"></use>
            </svg>
        </span>
        <span
            title="Add to favourites"
            class="icon-link favorites-toggle__off"
            v-else
        >
            <svg viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="#svg-icn-fav-off"></use>
            </svg>
        </span>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import Cookies from 'js-cookie';

export default {
    props: {
        adSlug: {
            type: String,
            required: true,
        },
        value: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        ...mapState(['pageState']),
    },
    methods: {
        ...mapActions('user', [
            'setUserFavorite', 'unsetUserFavorite',
        ]),
        async toggleFavorite() {
            let ad;
            if (this.value) {
                ad = await this.unsetUserFavorite(this.adSlug);
            } else {
                if (!this.pageState.isAuthUser) {
                    Cookies.set('krispy_favorite_ad_slug', this.adSlug, { expires: 1 });
                }
                ad = await this.setUserFavorite(this.adSlug);
            }
            this.$emit('input', ad.auth_user.is_in_favorites);
            window.showToastSuccess(ad.auth_user.is_in_favorites ? 'Successfully added to favourites.' : 'Successfully removed from favourites.');
        },
    },
};
</script>
